import { useCallback, useReducer } from "react";
import { ViewOptionStateEnum } from "../../../components/contextual-app-bar/ViewOptionStateEnum";

type AlarmScheduleListStateType = {
    viewOptionState: ViewOptionStateEnum;
    filterText: string;
    isDirty: boolean;
};

export const defaultState: AlarmScheduleListStateType = {
    viewOptionState: ViewOptionStateEnum.Default,
    filterText: '',
    isDirty: false,
};


enum AlarmScheduleListStateActionEnum {
    FilterTextChanged = 'ALARM_SCHEDULE_FILTER_TEXT_CHANGED',
    Reset = 'ALARM_SCHEDULE_RESET_CHANGED'
}


type AlarmScheduleListStateActionType = {
    type: AlarmScheduleListStateActionEnum.FilterTextChanged;
    payload: string;
} | {
    type: AlarmScheduleListStateActionEnum.Reset;
    payload: void;
};


const optionsChanged = (newState: AlarmScheduleListStateType, 
    defaultState: AlarmScheduleListStateType) => 
        newState.filterText !== defaultState.filterText;


function reducer(state: AlarmScheduleListStateType, action: AlarmScheduleListStateActionType): AlarmScheduleListStateType {

    const copy = { ...state };
    switch (action.type) {

        case AlarmScheduleListStateActionEnum.Reset:
            return {...defaultState};

        case AlarmScheduleListStateActionEnum.FilterTextChanged:
            copy.filterText = action.payload;

            copy.viewOptionState = optionsChanged(copy, defaultState) ? 
                                    ViewOptionStateEnum.Changed : 
                                    ViewOptionStateEnum.Default;

            return copy;

        default: 
            return {
                ...state
            };
    }
}

export default function useAlarmScheduleListState() {
    const [state, dispatch] = useReducer(reducer, defaultState);

    const setFilterText = useCallback((value: string) => dispatch({
        type: AlarmScheduleListStateActionEnum.FilterTextChanged,
        payload: value
    }), []);

    

    const resetState = useCallback(() => dispatch({
        type: AlarmScheduleListStateActionEnum.Reset,
        payload: undefined
    }), []);


    return {
        state,
        setFilterText,
        resetState
    };
}    
